<div class="h-full flex flex-col">
    <!-- header -->
    <div class="pt-8 pb-5 pl-8 pr-8 flex-shrink-0">
        <app-page-header
            title="Administración de Chatbots"
            subtitle="Gestiona y configura tus chatbots"
        >
            <ng-template #headerAction>
                <button 
                    mat-raised-button 
                    color="primary"
                    (click)="openCreateModal()"
                    class="flex items-center gap-2 !bg-light-primary dark:!bg-dark-primary !text-white hover:!bg-light-primary-variant dark:hover:!bg-dark-primary-variant !rounded-xl !px-6 !py-5 !shadow-soft hover:!shadow-medium transition-all duration-200">
                    <lucide-angular [img]="Plus" class="w-5 h-5"></lucide-angular>
                    Nuevo Chatbot
                </button>
            </ng-template>
        </app-page-header>
    </div>
    <!-- Generic Data Table -->
    <div class="px-8 pb-8 flex-1 min-h-0 overflow-auto dark:[color-scheme:dark]">
        <app-data-table
            [data]="filterActiveChatbots()"
            [columns]="tableColumns"
            [actions]="tableActions"
            [loading]="loading()"
            [config]="tableConfig"
            [searchFunction]="searchFunction"
            tableCaption="Lista de chatbots">

            <!-- Custom Filters Template -->
            <ng-template #customFilters>
                <mat-checkbox
                    [checked]="activeOnly()"
                    (change)="activeOnly.set($event.checked)"
                    color="primary"
                    class="ml-4 mb-4">
                    Solo activos
                </mat-checkbox>
            </ng-template>
        </app-data-table>
    </div>
</div>